import { Map as ImmutableMap, List as ImmutableList, fromJS } from 'immutable';
import {
  CHATS_FETCH_SUCCESS,
  CHAT_FETCH_SUCCESS,
  CHAT_CREATE_SUCCESS,
  CHAT_MESSAGES_FETCH_SUCCESS,
  CHAT_MESSAGE_SEND_SUCCESS,
} from '../actions/chats';

const initialState = ImmutableMap({
  items: ImmutableList(),
  messages: ImmutableMap(),
  isLoading: false,
});

const normalizeChat = (chat) => {
  return {
    ...chat,
    other_account_id: chat.other_account?.id || chat.other_account_id,
    other_account: undefined, // Remove the nested account object
  };
};

export default function chats(state = initialState, action) {
  switch (action.type) {
  case CHATS_FETCH_SUCCESS:
    return state.set('items', fromJS(action.chats.map(normalizeChat)));
  case CHAT_FETCH_SUCCESS:
  case CHAT_CREATE_SUCCESS:
    return state.update('items', list => {
      const normalizedChat = fromJS(normalizeChat(action.chat));
      const index = list.findIndex(item => item.get('id') === action.chat.id);
      if (index > -1) {
        return list.set(index, normalizedChat);
      } else {
        return list.unshift(normalizedChat);
      }
    });
  case CHAT_MESSAGES_FETCH_SUCCESS:
    return state.setIn(['messages', action.chatId], fromJS(action.messages));
  case CHAT_MESSAGE_SEND_SUCCESS:
    return state.updateIn(['messages', action.chatId], ImmutableList(), list => 
      list.push(fromJS(action.message))
    );
  default:
    return state;
  }
}
